import script from "./AiCheckBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCheckBanner.vue?vue&type=script&setup=true&lang=js"

import "./AiCheckBanner.vue?vue&type=style&index=0&id=18d55165&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18d55165"]])

export default __exports__